import React from 'react';

import BudgetInput from './Inputs/BudgetInput'
import TypeCheckbox from './Inputs/TypeCheckbox'
import RoomRadio from './Inputs/RoomRadio'
import SurfaceInput from './Inputs/SurfaceInput'
import MoreCriteriaCheckbox from './Inputs/MoreCriteriaCheckbox'

const MobileFilters = () => {
  return(
    <>
      <TypeCheckbox />
      <BudgetInput />
      <RoomRadio />
      <SurfaceInput />
      <MoreCriteriaCheckbox />
    </>
  )
};

export default MobileFilters;
